import React, { useEffect } from "react";
import ImageCarousel from "./ImageCarousel";
import LatestWork from "./LatestWork";
import { Helmet } from "react-helmet";

const slides = [
  {
    url: "https://res.cloudinary.com/dn0c3esmd/image/upload/v1772995103/Shore_Acres_1_qbpw1l.jpg",
    description: "Shore Acres #1",
    collection: "Oregon Coast",
  },
  {
    url: "https://res.cloudinary.com/dn0c3esmd/image/upload/v1731306628/august_sunset_jmybqj.jpg",
    description: "August Sunset in West Seattle",
    collection: "Washington",
  },
  {
    url: "https://res.cloudinary.com/dn0c3esmd/image/upload/v1725656118/Autumn_Cascades_ifimuy.jpg",
    description: "Autumn in the Cascades",
    collection: "Washington",
  },

];

function Home({ excludedFolders, excludedImages }) {
  useEffect(() => {
    document.title = "Chris Smith Creative";
  }, []);

  return (
    <>
          <Helmet>
      <title>Chris Smith Creative | Watercolor Landscape Paintings</title>

      <meta
        name="description"
        content="Nature-inspired watercolor landscapes from Casco Bay, Puget Sound, and the Pacific Northwest."
      />

      <meta
        property="og:title"
        content="Chris Smith Creative | Watercolor Landscape Paintings"
      />

      <meta
        property="og:description"
        content="Nature-inspired watercolor landscapes from Casco Bay, Puget Sound, and the Pacific Northwest."
      />

      <meta
        property="og:image"
        content="https://res.cloudinary.com/dn0c3esmd/image/upload/v1725656118/Autumn_Cascades_ifimuy.jpg"
      />
    </Helmet>

    <div>
      <ImageCarousel slides={slides} interval={10000} />

      <LatestWork
        excludedFolders={excludedFolders}
        excludedImages={excludedImages}
      />
    </div>
    </>
  );
}

export default Home;